(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gps-support"] && !Shopify.designMode) return;
  try {
    
function initGpsSupport(){
const root=document.querySelector('.gps-support');
if(!root||root.dataset.ready)return;
root.dataset.ready='true';
const form=root.querySelector('form');
if(!form||!form.querySelector('#gps-Product'))return;
const product=form.querySelector('#gps-Product');
const other=root.querySelector('[data-other-model]');
const model=other.querySelector('input');
function toggleModel(){const selected=product.value==='Ander of ouder model';other.hidden=!selected;model.required=selected;model.disabled=!selected;}
product.addEventListener('change',toggleModel);toggleModel();
const order=form.querySelector('#gps-Ordernummer'),imei=form.querySelector('#gps-IMEI');
function clean(){order.value=order.value.trim();imei.value=imei.value.replace(/\s/g,'');}
[order,imei].forEach(el=>{el.addEventListener('change',clean);el.addEventListener('input',()=>el.setCustomValidity(''));el.addEventListener('invalid',()=>{if(el.validity.patternMismatch)el.setCustomValidity(el.dataset.error);});});
const date=form.querySelector('#gps-Datum'),time=form.querySelector('#gps-Tijdstip');
function dutchNow(){const parts=new Intl.DateTimeFormat('sv-SE',{timeZone:'Europe/Amsterdam',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).formatToParts(new Date());const p=Object.fromEntries(parts.map(v=>[v.type,v.value]));return p.year+'-'+p.month+'-'+p.day+'T'+p.hour+':'+p.minute;}
function validateTime(){const now=dutchNow();date.max=now.slice(0,10);time.setCustomValidity(date.value&&time.value&&date.value+'T'+time.value>now?root.querySelector('[data-gps-future-error]').textContent:'');}
date.addEventListener('change',validateTime);time.addEventListener('input',validateTime);validateTime();
form.querySelectorAll('input[required][type=text],textarea[required]').forEach(el=>{el.addEventListener('input',()=>el.setCustomValidity(''));el.addEventListener('change',()=>{el.setCustomValidity(el.value.trim()?'':root.querySelector('[data-gps-blank-error]').textContent);});});
form.addEventListener('submit',event=>{clean();validateTime();if(!form.reportValidity())event.preventDefault();});
}
initGpsSupport();
document.addEventListener('shopify:section:load',initGpsSupport);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
